var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar-brand',{staticClass:"text-light"},[(_vm.group.logo_url)?_c('img',{staticStyle:{"filter":"brightness(0) invert(1)"},attrs:{"height":"32","src":_vm.group.logo_url}}):_c('LogoPlaceholder')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }